import { GET_REPORTS, GET_REPORT_TITLES, GET_REGISTERED_USERS, SET_REPORT, GET_RECIEPTS } from "./types";
import firebase from "firebase/app";
import moment from "moment"
// let date = new Date();
// let currentYear = moment(date).format("YYYY")
// let currentMonth = moment(date).format("MMM").toLowerCase()

export const getJobPack = (jobpack_uid = false, st = false, year = false, month = false) => {
    return dispatch => {
        dispatch({ type: GET_REPORTS.REQUEST });

        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user) {
                    firebase
                        .database()
                        .ref(`/subjects/jobpacks/${st}/${year}/${month}/${jobpack_uid}`)
                        .on("value", snapshot => {
                            dispatch({
                                type: GET_REPORTS.SUCCESS,
                                payload: snapshot.val()
                            });
                        });
                } else {
                    dispatch({ type: GET_REPORTS.FAIL });
                }
            });
        } catch {
            dispatch({ type: GET_REPORTS.FAIL });
        }
    };
};

export const getReportTitles = () => {
    return dispatch => {
        dispatch({ type: GET_REPORT_TITLES.REQUEST });

        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user) {
                    firebase
                        .database()
                        .ref(`/collections/report_titles/`)
                        .on("value", snapshot => {
                            dispatch({
                                type: GET_REPORT_TITLES.SUCCESS,
                                payload: snapshot.val()
                            });
                        });
                } else {
                    dispatch({ type: GET_REPORT_TITLES.FAIL });
                }
            });
        } catch {
            dispatch({ type: GET_REPORT_TITLES.FAIL });
        }
    };
};
export const getRegisteredUsers = () => {
    return dispatch => {
        dispatch({ type: GET_REGISTERED_USERS.REQUEST });
        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({ type: GET_REGISTERED_USERS.FAIL });
                } else {
                    firebase
                        .database()
                        .ref(`/users`)
                        .on("value", snapshot => {
                            dispatch({
                                type: GET_REGISTERED_USERS.SUCCESS,
                                payload: snapshot.val()
                            });
                        });
                }
            });
        } catch (e) {
            dispatch({ type: GET_REGISTERED_USERS.FAIL });
        }
    };
};


export const setReport = (newGroup = false, jobpackReports, jobpack_uid = false, timeStamp ,reportType , userId, st = false, year = false, month = false) => {    
    let reportData = jobpackReports[reportType][timeStamp];
    let currentYear = moment(timeStamp,"DD-MM-YYYY HH:mm:ss").year()
    let currentMonth = moment(timeStamp,"DD-MM-YYYY HH:mm:ss").format("MMM").toLowerCase()
    return dispatch => {
        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user) {
                    firebase
                        .database()
                        .ref(`/subjects/reports/${newGroup}/reports/${reportType}/`)
                        .child(timeStamp)
                        .update(reportData)
                        .then(() => {
                            firebase
                                .database()
                                .ref(`/users/${userId}/receipts/${currentYear}/${currentMonth}/${reportType}/${timeStamp}/`)
                                .remove()
                                .then(() => {
                                    firebase
                                        .database()
                                        .ref(`/users/${newGroup}/receipts/${currentYear}/${currentMonth}/${reportType}/`)
                                        .child(timeStamp)
                                        .update({ subject_child: newGroup, subject_name: "reports", report_type: reportType, timestamp: timeStamp })
                                        .then(() => {
                                            firebase
                                                .database()
                                                .ref(`/subjects/jobpacks/${st}/${year}/${month}/${jobpack_uid}/reports/${reportType}/${timeStamp}/`)
                                                .remove()
                                            dispatch({
                                                type: SET_REPORT.SUCCESS
                                            })
                                        })
                                })                                
                        }
                        )
                        .catch(() => {
                            dispatch({ type: SET_REPORT.FAIL })
                        })
                } else {
                    dispatch({ type: SET_REPORT.FAIL });
                }
            });
        } catch {
            dispatch({ type: SET_REPORT.FAIL });
        }
    };
};

export const getReciepts = (userId = false, reportType = false, timestamp = false ) => {
    return dispatch => {
        dispatch({ type: GET_RECIEPTS.REQUEST });

        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user) {
                    firebase
                        .database()
                       .ref(`/users/${userId}/reports/${reportType}/${timestamp}`)
                        .on("value", snapshot => {
                            dispatch({
                                type: GET_RECIEPTS.SUCCESS,
                                payload: snapshot.val()
                            });
                        });
                } else {
                    dispatch({ type: GET_RECIEPTS.FAIL });
                }
            });
        } catch {
            dispatch({ type: GET_RECIEPTS.FAIL });
        }
    };
}